var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "liquids-item" }, [
    _c("div", { staticClass: "liquids-item__inner" }, [
      _c("h3", { staticClass: "liquids-item__headline" }, [
        _vm._v(_vm._s(_vm.liquidItem.Name))
      ]),
      _vm._v(" "),
      _vm.liquidItem.HasDescription
        ? _c("p", {
            staticClass: "liquids-item__teaser",
            domProps: { innerHTML: _vm._s(_vm.liquidItem.Description) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.liquidItem.HasDetails
        ? _c(
            "div",
            { staticClass: "liquids-item__extra" },
            _vm._l(_vm.liquidItem.Details, function(liquidItemDetail, index) {
              return _c(
                "div",
                { key: index, staticClass: "liquids-item__extra-row" },
                [
                  liquidItemDetail.Title.length
                    ? _c("div", { staticClass: "liquids-item__extra-col" }, [
                        _vm._v(_vm._s(liquidItemDetail.Title))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  liquidItemDetail.Description.length
                    ? _c("div", {
                        staticClass: "liquids-item__extra-col",
                        domProps: {
                          innerHTML: _vm._s(liquidItemDetail.Description)
                        }
                      })
                    : _vm._e()
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.liquidItem.Products.length,
              expression: "liquidItem.Products.length"
            }
          ],
          staticClass: "products-section"
        },
        [
          _c("div", { staticClass: "products-items__text" }, [
            _c("div", { staticClass: "products-items__headline" }, [
              _vm._v(_vm._s(_vm.dictionaries.LiquidIncludedProducts))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "products-items" },
            _vm._l(_vm.liquidItem.Products, function(productItem) {
              return _c("productItem", {
                key: productItem.Id,
                attrs: { productItem: productItem }
              })
            }),
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b2d4596", { render: render, staticRenderFns: staticRenderFns })
  }
}